import { render } from "./TextInput.vue?vue&type=template&id=3f353feb&bindings={\"value\":\"props\",\"align\":\"props\",\"padding\":\"props\"}"
import script from "./TextInput.vue?vue&type=script&lang=js"
export * from "./TextInput.vue?vue&type=script&lang=js"

import "./TextInput.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script